import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
    closeDialogMessage: boolean;
    title: string;
    redirectLink: string;
    redirectText: string;
    continueText: string;
    redirectWithRefresh: string;
    redirectWithRefreshText: string;
    addClass: string;
}

declare let _: any;

@Component({
    selector: 'success-modal',
    templateUrl: './success-modal.html',
    styleUrls: ['./success-modal.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AddToSuccessModalComponentGeneric  {

    constructor(public dialogRef: MatDialogRef<AddToSuccessModalComponentGeneric>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    onConfirm(): void {
        // Close the dialog, return true
        this.dialogRef.close(true);
    }

    onDismiss(): void {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }




}
